// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"9879e1cc","453":"6f4cc14d","777":"38ba177d"}[chunkId] + ".chunk.js";
};